import { type RefObject, useMemo, useRef } from 'react';
import { useResizable } from 'react-resizable-layout';
import {
  CONFIG_PANEL_INITIAL_WIDTH_PX,
  CONFIG_PANEL_MAX_WIDTH_PX,
  CONFIG_PANEL_MIN_WIDTH_PX,
} from 'src/pages/Settings/memberships/styled';
import { useMembershipsConfigStore } from 'src/store/memberships-config';
import { useScreenDimensions } from 'src/utils/system';

export const useConfigPanelResize = () => {
  const { isMobile } = useScreenDimensions();
  const savedConfigPanelWidth = useMembershipsConfigStore.use.configPanelWidth();
  const setSavedConfigPanelWidth = useMembershipsConfigStore.use.setConfigPanelWidth();
  const containerRef = useRef<HTMLDivElement | null>(null);
  const initialConfigPanelWidth = savedConfigPanelWidth ?? CONFIG_PANEL_INITIAL_WIDTH_PX;
  const { position, separatorProps, isDragging } = useResizable({
    axis: 'x',
    initial: initialConfigPanelWidth,
    min: CONFIG_PANEL_MIN_WIDTH_PX,
    max: CONFIG_PANEL_MAX_WIDTH_PX,
    containerRef: containerRef as RefObject<HTMLElement>,
    reverse: true,
    disabled: isMobile,
    onResizeEnd: ({ position }) => {
      setSavedConfigPanelWidth(position);
    },
  });

  const configPanelWidth = useMemo(() => {
    const nextWidth = position || initialConfigPanelWidth;
    return Math.min(CONFIG_PANEL_MAX_WIDTH_PX, Math.max(nextWidth, CONFIG_PANEL_MIN_WIDTH_PX));
  }, [initialConfigPanelWidth, position]);

  return { containerRef, separatorProps, isDragging, configPanelWidth };
};
